import { BaseAPI } from "@emcd-shared/api-service";
import { store } from "@/app/store";
import {
  requestErrorInterceptor,
  requestInterceptor,
  responseErrorInterceptor,
  responseInterceptor,
} from "@emcd-shared/auth-service/api";
import CONFIG from "@/app/config";

export class CustomApiService extends BaseAPI {
  constructor(app) {
    super(CONFIG.EXPLORER_URL);
    this.client.interceptors.request.use(
      requestInterceptor,
      requestErrorInterceptor,
    );

    // Кастомная функция-обертка для обработки ошибок 503
    const custom503ErrorHandler = (error) => {
      // Проверяем статус 503
      if (error.response && error.response.status === 503) {
        // Получаем текущие параметры URL
        const currentUrl = new URL(window.location.href);
        const currentPath = currentUrl.pathname;
        // Разбираем путь на компоненты (удаляем начальный слеш, если есть)
        const pathParts = currentPath.replace(/^\/explorer\//, "").split("/");

        // Проверяем, что у нас есть хотя бы тип данных и сеть
        if (pathParts.length >= 2) {
          const network = pathParts[0]; // bitcoin, tron, и т.д.
          const type = pathParts[1]; // address, transaction, new-block
          const value = pathParts[2] || ""; // идентификатор (хеш, адрес)

          // Преобразуем тип для blockchair
          let blockchairType = type;
          if (type === "new-block") {
            blockchairType = "block";
          }

          // Формируем новый URL для blockchair в формате network/type/value
          let blockchairPath = `${network}/${blockchairType}/${value}`;

          // Создаем полный URL для перенаправления
          const redirectUrl = new URL(
            `https://blockchair.com/${blockchairPath}`,
          );

          // Копируем все параметры из текущего URL
          currentUrl.searchParams.forEach((value, key) => {
            redirectUrl.searchParams.append(key, value);
          });

          // Выполняем редирект
          window.location.href = redirectUrl.toString();
        } else {
          // Если структура URL не соответствует ожидаемой, редиректим на главную страницу blockchair
          window.location.href = "https://blockchair.com/";
        }

        return Promise.reject(error);
      }

      // Для всех остальных ошибок используется стандартный обработчик
      return responseErrorInterceptor(
        this.client,
        (res) => {
          store.dispatch("auth/authenticate", res);
        },
        app,
      )(error);
    };

    this.client.interceptors.response.use(
      responseInterceptor,
      custom503ErrorHandler,
    );
  }
}

export default CustomApiService;
